import { render, staticRenderFns } from "./Freeissueorder.vue?vue&type=template&id=37cdf61c&scoped=true"
import script from "./Freeissueorder.vue?vue&type=script&lang=js"
export * from "./Freeissueorder.vue?vue&type=script&lang=js"
import style0 from "./Freeissueorder.vue?vue&type=style&index=0&id=37cdf61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cdf61c",
  null
  
)

export default component.exports